import { Stack, Typography, useMediaQuery } from "@mui/material";
import founderConstants from "../../data/about/founder.json";
import { baseurl } from "../../config";

type Props = {};

const Founder = (props: Props) => {
  const isSmallScreen = useMediaQuery("(max-width:650px)");
  return (
    <Stack direction="column" spacing={2}>
      <Typography variant="h4" sx={{ fontFamily: "inherit" }}>
        {founderConstants?.title}
        <br />
        <Typography sx={{ fontFamily: "inherit" }} variant="body2">
          {founderConstants?.subtitle}
        </Typography>
      </Typography>

      <img
        src={`${baseurl}${founderConstants?.emblem}`}
        alt={`${founderConstants?.title}`}
        width="200px"
        style={{
          margin: isSmallScreen ? "1rem auto" : "1.5rem auto",
          borderRadius: "282px 282px 0px 0px",
        }}
      />
      <Stack direction="column" spacing={2}>
        {founderConstants?.description?.map((desc: string, index: number) => (
          <Typography
            sx={{ fontFamily: "inherit" }}
            variant="body2"
            textAlign="justify"
            key={index}
          >
            {desc}
          </Typography>
        ))}
      </Stack>
    </Stack>
  );
};

export default Founder;
